<template>
    <section>
        <div class="row">
            <div class="col-12">
                <report-menu-option @reportOption="setReportOption($event)"></report-menu-option>
            </div>
        </div>
        <div class="row" v-if="reportOption === 1 || reportOption === 2">
            <div class="col-12">
                <report-chart-dashboard :reportOption="reportOption"></report-chart-dashboard>
            </div>
        </div>
        <div class="row" v-if="reportOption === 3">
            <div class="col-12">
            
            </div>
        </div>
    </section>
</template>

<script>
import ReportMenuOption from '@/components/report/MenuOption';
import ReportChartDashboard from '@/components/report/ChartDashboard';

export default {
    components: {
        ReportMenuOption,
        ReportChartDashboard
    },
    data() {
        return {
            reportOption: -1
        }
    },
    methods: {
        setReportOption(value) {
            this.reportOption = value;
        }
    }
}
</script>